import { render, staticRenderFns } from "./History.vue?vue&type=template&id=43906f6c&scoped=true&"
import script from "../js/Historical.js?vue&type=script&lang=js&"
export * from "../js/Historical.js?vue&type=script&lang=js&"
import style0 from "../styles/Historical.sass?vue&type=style&index=0&id=43906f6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43906f6c",
  null
  
)

export default component.exports